import { useEffect, useState } from "react";
import { ArrowUpRight, Menu, X } from "lucide-react";
import { motion, useScroll, useSpring } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { scrollToSection } from "@/lib/scroll";
import { useLanguage } from "@/i18n/LanguageContext";

const LINKS = ["work", "services", "founders"];
export default function Nav() {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 160, damping: 30 });
  useEffect(() => {
    const close = e => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("keydown", close);
    return () => document.removeEventListener("keydown", close);
  }, []);
  const go = id => {
    setOpen(false);
    const path = id === "top" ? "/" : id === "founders" ? "/studio" : `/${id}`;
    if (pathname === path) scrollToSection("top");
    else navigate(path);
  };
  return (
    <header className="studio-header">
      <nav className="studio-container studio-nav" aria-label={t("refresh.navigation")}>
        <button data-testid="nav-logo-button" className="nav-wordmark" onClick={() => go("top")} aria-label="Web Builders home"><span className="nav-monogram">W<span>B</span></span><span className="nav-brand">WEB<br />BUILDERS</span></button>
        <div className="nav-links">{LINKS.map((id, i) => <button key={id} data-testid={`nav-link-${id}`} className="nav-link" onClick={() => go(id)}><span className="nav-link-index">0{i + 1}</span>{t(`nav.${id}`)}</button>)}</div>
        <div className="nav-tools"><LanguageSwitcher /><button data-testid="nav-cta-button" className="nav-cta" onClick={() => go("contact")}>{t("nav.cta")}<ArrowUpRight size={16} /></button><button data-testid="nav-menu-toggle" className="mobile-menu-toggle icon-button" onClick={() => setOpen(!open)} aria-expanded={open} aria-controls="mobile-navigation" aria-label={t(open ? "refresh.close" : "refresh.menu")}>{open ? <X size={22} /> : <Menu size={22} />}</button></div>
      </nav>
      {open && <div id="mobile-navigation" data-testid="mobile-navigation" className="mobile-navigation">{[...LINKS, "contact"].map((id, i) => <button key={id} data-testid={`mobile-nav-${id}`} onClick={() => go(id)}><span className="mono-label">0{i + 1}</span>{t(id === "contact" ? "nav.cta" : `nav.${id}`)}<ArrowUpRight size={20} /></button>)}</div>}
      <motion.div className="reading-progress" style={{ scaleX }} aria-hidden="true" />
    </header>
  );
}